/* eslint-disable */

/**
  * <Toolbar />
  */

import React from 'react';
import { withTranslation } from 'react-i18next';
import ToolbarItem from './toolbar-draggable-item';
import { v4 as uuidv4 } from 'uuid';
import store from './stores/store';

function isDefaultItem(item) {
  const keys = Object.keys(item);
  return keys.filter(x => x !== 'element' && x !== 'key').length === 0;
}

function buildItems(items, defaultItems) {
  if (!items) {
    return defaultItems;
  }
  return items.map(x => {
    let found;
    if (isDefaultItem(x)) {
      found = defaultItems.find(y => (x.element || x.key) === (y.element || y.key));
    }
    return found || x;
  });
}

class Toolbar extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    const items = buildItems(props.items, this._defaultItems(t));
    this.state = {
      items,
    };
    this.create = this.create.bind(this);
  }

  componentDidMount() {
    store.subscribe(state => this.setState({ store: state }));
  }

  static _defaultItemOptions(element, t) {
    switch (element) {
      case 'Dropdown':
        return [
          { value: 'place_holder_option_1', text: t('survey.option_1'), key: `dropdown_option_${uuidv4()}` },
          { value: 'place_holder_option_2', text: t('survey.option_2'), key: `dropdown_option_${uuidv4()}` },
          { value: 'place_holder_option_3', text: t('survey.option_3'), key: `dropdown_option_${uuidv4()}` },
        ];
      case 'Tags':
        return [
          { value: 'place_holder_tag_1', text: t('survey.option_1'), key: `tags_option_${uuidv4()}` },
          { value: 'place_holder_tag_2', text: t('survey.option_2'), key: `tags_option_${uuidv4()}` },
          { value: 'place_holder_tag_3', text: t('survey.option_3'), key: `tags_option_${uuidv4()}` },
        ];
      case 'Checkboxes':
        return [
          { value: 'place_holder_option_1', text: t('survey.option_1'), key: `checkboxes_option_${uuidv4()}` },
          { value: 'place_holder_option_2', text: t('survey.option_2'), key: `checkboxes_option_${uuidv4()}` },
          { value: 'place_holder_option_3', text: t('survey.option_3'), key: `checkboxes_option_${uuidv4()}` },
        ];
      case 'RadioButtons':
        return [
          { value: 'place_holder_option_1', text: t('survey.option_1'), key: `radiobuttons_option_${uuidv4()}` },
          { value: 'place_holder_option_2', text: t('survey.option_2'), key: `radiobuttons_option_${uuidv4()}` },
          { value: 'place_holder_option_3', text: t('survey.option_3'), key: `radiobuttons_option_${uuidv4()}` },
        ];
      default:
        return [];
    }
  }

  _defaultItems(t) {
    return [
      {
        key: 'Header',
        name: t('survey.header_text'),
        icon: 'fas fa-heading',
        static: true,
        content: t('survey.placeholder_text'),
      },
      {
        key: 'Label',
        name: t('shared.label'),
        static: true,
        icon: 'fas fa-font',
        content: t('survey.placeholder_text'),
      },
      {
        key: 'Paragraph',
        name: t('survey.paragraph'),
        static: true,
        icon: 'fas fa-paragraph',
        content: t('survey.placeholder_text'),
      },
      {
        key: 'LineBreak',
        name: t('survey.line_break'),
        static: true,
        icon: 'fas fa-arrows-alt-h',
      },
      {
        key: 'Dropdown',
        canHaveAnswer: true,
        name: t('survey.dropdown'),
        icon: 'far fa-caret-square-down',
        label: t('survey.placeholder_label'),
        field_name: 'dropdown_',
        options: [],
      },
      {
        key: 'Tags',
        canHaveAnswer: true,
        name: t('survey.tags'),
        icon: 'fas fa-tags',
        label: t('survey.placeholder_label'),
        field_name: 'tags_',
        options: [],
      },
      {
        key: 'Checkboxes',
        canHaveAnswer: true,
        name: t('survey.checkboxes'),
        icon: 'far fa-check-square',
        label: t('survey.placeholder_label'),
        field_name: 'checkboxes_',
        options: [],
      },
      {
        key: 'RadioButtons',
        canHaveAnswer: true,
        name: t('survey.multiple_choice'),
        icon: 'far fa-dot-circle',
        label: t('survey.placeholder_label'),
        field_name: 'radiobuttons_',
        options: [],
      },
      {
        key: 'TextInput',
        canHaveAnswer: true,
        name: t('survey.text_input'),
        label: t('survey.placeholder_label'),
        icon: 'fas fa-font',
        field_name: 'text_input_',
      },
      {
        key: 'EmailInput',
        canHaveAnswer: true,
        name: t('user.email'),
        label: t('user.email'),
        icon: 'fas fa-envelope',
        field_name: 'email_input_',
      },
      {
        key: 'NumberInput',
        canHaveAnswer: true,
        name: t('survey.number_input'),
        label: t('survey.placeholder_label'),
        icon: 'fas fa-plus',
        field_name: 'number_input_',
      },
      {
        key: 'PhoneNumber',
        canHaveAnswer: true,
        name: t('address.phone_number'),
        label: t('address.phone_number'),
        icon: 'fas fa-phone',
        field_name: 'phone_input_',
      },
      {
        key: 'TextArea',
        canHaveAnswer: true,
        name: t('survey.multi_line_input'),
        label: t('survey.placeholder_label'),
        icon: 'fas fa-text-height',
        field_name: 'text_area_',
      },
      // {
      //   key: 'TwoColumnRow',
      //   canHaveAnswer: false,
      //   name: '2 - Tabelle',
      //   label: '',
      //   icon: 'fas fa-columns',
      //   field_name: 'two_col_row_',
      // },
      // {
      //   key: 'ThreeColumnRow',
      //   canHaveAnswer: false,
      //   name: '3 - Tabelle',
      //   label: '',
      //   icon: 'fas fa-columns',
      //   field_name: 'three_col_row_',
      // },
      // {
      //   key: 'FourColumnRow',
      //   canHaveAnswer: false,
      //   name: '4 - Tabelle',
      //   label: '',
      //   icon: 'fas fa-columns',
      //   field_name: 'four_col_row_',
      // },
      {
        key: 'Image',
        name: 'Image',
        label: '',
        icon: 'far fa-image',
        field_name: 'image_',
        src: '',
      },
      {
        key: 'Rating',
        canHaveAnswer: true,
        name: t('survey.rating'),
        label: t('survey.placeholder_label'),
        icon: 'fas fa-star',
        field_name: 'rating_',
      },
      {
        key: 'DatePicker',
        canDefaultToday: true,
        canReadOnly: false,
        dateFormat: 'date',
        timeFormat: 'hh:mm aa',
        showTimeSelect: false,
        showTimeSelectOnly: false,
        showTimeInput: false,
        name: t('shared.date'),
        icon: 'far fa-calendar-alt',
        label: t('survey.placeholder_label'),
        field_name: 'date_picker_',
      },
      {
        key: 'Signature',
        canReadOnly: true,
        name: t('survey.signature'),
        icon: 'fas fa-pen-square',
        label: t('survey.signature'),
        field_name: 'signature_',
      },
      {
        key: 'HyperLink',
        name: t('survey.website'),
        icon: 'fas fa-link',
        static: true,
        content: t('survey.placeholder_website_link'),
        href: 'http://www.example.com',
      },
      // {
      //   key: 'Download',
      //   name: t({ id: 'file-attachment' }),
      //   icon: 'fas fa-file',
      //   static: true,
      //   content: t({ id: 'place-holder-file-name' }),
      //   field_name: 'download_',
      //   file_path: '',
      //   _href: '',
      // },
      // {
      //   key: 'Range',
      //   name: t({ id: 'range' }),
      //   icon: 'fas fa-sliders-h',
      //   label: t('survey.placeholder_label'),
      //   field_name: 'range_',
      //   step: 1,
      //   default_value: 3,
      //   min_value: 1,
      //   max_value: 5,
      //   min_label: t({ id: 'easy' }),
      //   max_label: t({ id: 'difficult' }),
      // },
      // {
      //   key: 'Camera',
      //   name: t({ id: 'camera' }),
      //   icon: 'fas fa-camera',
      //   label: t('survey.placeholder_label'),
      //   field_name: 'camera_',
      // },
      // {
      //   key: 'FileUpload',
      //   name: t('survey.file_upload'),
      //   icon: 'fas fa-file',
      //   label: t('survey.placeholder_label'),
      //   field_name: 'file_upload_',
      // },
    ];
  }

  create(item) {
    const { t } = this.props;

    const elementOptions = {
      id: uuidv4(),
      element: item.element || item.key,
      text: item.name,
      static: item.static,
      required: false,
      showDescription: item.showDescription,
    };

    if (this.props.showDescription === true && !item.static) {
      elementOptions.showDescription = true;
    }

    if (item.type === 'custom') {
      elementOptions.key = item.key;
      elementOptions.custom = true;
      elementOptions.forwardRef = item.forwardRef;
      elementOptions.bare = item.bare;
      elementOptions.props = item.props;
      elementOptions.component = item.component || null;
      elementOptions.custom_options = item.custom_options || [];
    }

    if (item.static) {
      elementOptions.bold = false;
      elementOptions.italic = false;
    }

    if (item.canHaveAnswer) { elementOptions.canHaveAnswer = item.canHaveAnswer; }

    if (item.canReadOnly) { elementOptions.readOnly = false; }

    if (item.canDefaultToday) { elementOptions.defaultToday = false; }

    if (item.content) { elementOptions.content = item.content; }

    if (item.href) { elementOptions.href = item.href; }

    elementOptions.canHavePageBreakBefore = item.canHavePageBreakBefore !== false;
    elementOptions.canHaveAlternateForm = item.canHaveAlternateForm !== false;
    elementOptions.canHaveDisplayHorizontal = item.canHaveDisplayHorizontal !== false;
    if (elementOptions.canHaveDisplayHorizontal) {
      elementOptions.inline = item.inline;
    }
    elementOptions.canHaveOptionCorrect = item.canHaveOptionCorrect !== false;
    elementOptions.canHaveOptionValue = item.canHaveOptionValue !== false;
    elementOptions.canPopulateFromApi = item.canPopulateFromApi !== false;

    if (item.class_name) {
      elementOptions.class_name = item.class_name;
    }

    if (item.key === 'Image') {
      elementOptions.src = item.src;
    }

    if (item.key === 'DatePicker') {
      elementOptions.dateFormat = item.dateFormat;
      elementOptions.timeFormat = item.timeFormat;
      elementOptions.showTimeSelect = item.showTimeSelect;
      elementOptions.showTimeSelectOnly = item.showTimeSelectOnly;
      elementOptions.showTimeInput = item.showTimeInput;
    }

    if (item.key === 'Download') {
      elementOptions._href = item._href;
      elementOptions.file_path = item.file_path;
    }

    if (item.key === 'Range') {
      elementOptions.step = item.step;
      elementOptions.default_value = item.default_value;
      elementOptions.min_value = item.min_value;
      elementOptions.max_value = item.max_value;
      elementOptions.min_label = item.min_label;
      elementOptions.max_label = item.max_label;
    }

    if (item.defaultValue) { elementOptions.defaultValue = item.defaultValue; }

    if (item.field_name) { elementOptions.field_name = item.field_name + uuidv4(); }

    if (item.label) { elementOptions.label = item.label; }

    if (item.options) {
      if (item.options.length > 0) {
        elementOptions.options = item.options;
      } else {
        elementOptions.options = Toolbar._defaultItemOptions(elementOptions.element, t);
      }
    }

    return elementOptions;
  }

  _onClick(item) {
    // ElementActions.createElement(this.create(item));
    store.dispatch('create', this.create(item));
  }

  render() {
    return (
      <div className="w-1/4 px-4 react-form-builder-toolbar h-full float-right">
        <h4>{this.props.t('survey.toolbox')}</h4>
        <ul>
          {
            this.state.items.map((item) => (<ToolbarItem data={item} key={item.key} onClick={this._onClick.bind(this, item)} onCreate={this.create} />))
          }
        </ul>
      </div>
    );
  }
}

export default withTranslation()(Toolbar);
